import { IntlShape } from 'react-intl';

import { SelectConfiguredOption } from '@app/hooks';
import { getFormattedDate } from '@app/utils';
import {
  holdMessages,
  itemStatusPanelButtonMessages,
  loanMessages,
} from '@app/translations';
import {
  ItemStatus,
  ItemStatusData,
  ItemWithStatus,
  statusIconMap,
} from '@app/constants';

import { getCheckoutsStatusMessage } from './getCheckoutsStatusesData';
import { getStatusMessage } from './getStatusMessage';

export const HOLD_STATUS_MESSAGE_MAP = {
  'Open - Not yet filled': holdMessages.queue,
  'Open - Awaiting pickup': holdMessages.readyForPickup,
  'Open - In transit': holdMessages.queue,
  'Open - Awaiting delivery': holdMessages.queue,
};

// TODO: Add types for data
const convertStatusToStatusData = (
  data,
  intl: IntlShape,
  locale: string,
  selectConfiguredOption: SelectConfiguredOption
) => {
  const actionButtonText = selectConfiguredOption(
    intl.$t(itemStatusPanelButtonMessages.goToRequestsAndLoans),
    intl.$t(itemStatusPanelButtonMessages.goToHoldsAndCheckouts)
  );

  if (Object.keys(HOLD_STATUS_MESSAGE_MAP).includes(data.status)) {
    return {
      icon: statusIconMap[ItemStatus.onHold],
      status: ItemStatus.onHold,
      statusMessage: getStatusMessage(data.status, intl, data.queuePosition),
      actionButtonText,
    };
  }

  const status = data.overdue ? ItemStatus.overdue : ItemStatus.checkedOut;
  const date = getFormattedDate({ date: data.dueDate, locale });
  const isoCurrencyCode = data.isoCurrencyCode;
  const feesValue =
    data.amount &&
    isoCurrencyCode &&
    intl.formatNumber(data.amount, {
      style: 'currency',
      currency: isoCurrencyCode,
    });

  return {
    icon: statusIconMap[status],
    status,
    statusMessage: getCheckoutsStatusMessage({
      date,
      intl,
    }),
    actionButtonText,
    feesTitle: intl.$t(loanMessages.fees),
    feesValue: feesValue || '',
  };
};

export const getItemStatusData = (
  itemWithStatus: ItemWithStatus,
  intl: IntlShape,
  locale: string,
  selectConfiguredOption: SelectConfiguredOption
): ItemStatusData => {
  const { item, ...rest } = itemWithStatus;
  const convertedStatusData = convertStatusToStatusData(
    rest,
    intl,
    locale,
    selectConfiguredOption
  );

  return {
    instanceId: item.instanceId,
    itemId: item.itemId,
    ...convertedStatusData,
  };
};
